import {
  Autocomplete,
  AutocompleteChangeReason,
  TextField,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ProductsModel, VehicleModel } from "../../Utils/Models";
import { Controller } from "react-hook-form";
import { EditProductProps } from "../../Utils/Types";
import styles from "../../Styles/products.module.css";
import { isMobile } from "../../Utils/Utils";
import { getVehicleLabel } from "../Vehicles/VehicleUtils";

export const EditVehicle = (props: EditProductProps) => {
  const [vehicles, setVehicles] = useState([] as VehicleModel[]);
  const [localError, setLocalError] = useState(false);
  const { id } = props;

  useEffect(() => {
    if (props?.vehicles?.length && props?.vehicles?.length > 0)
      setVehicles(props.vehicles);
  }, [props.vehicles]);

  const mapPropsForProduct = (product: any) => {
    const newProduct = Object.assign({}, new ProductsModel());
    newProduct.name = product?.name;
    return newProduct;
  };

  return (
    <Fragment>
      <Controller
        name={id ?? `vehicle_id`}
        control={props.control}
        defaultValue={null}
        render={({ field: { ref, ...field }, fieldState: { error } }) => {
          return (
            <>
              <Autocomplete
                disableClearable
                id={id ?? `vehicle_id`}
                disabled={props.disabled}
                fullWidth={true}
                className={styles.editProductOrderOffer}
                freeSolo={false}
                noOptionsText={Vocabulary.noResultsFound}
                isOptionEqualToValue={(option: any, value: any) => {
                  if (typeof value === "string") {
                    return option._id === value;
                  } else {
                    return option?._id === value?._id;
                  }
                }}
                getOptionLabel={(option: any) =>
                  getVehicleLabel(option, vehicles)
                }
                options={vehicles || []}
                value={field.value}
                onChange={(
                  e: any,
                  product: string,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => {
                  props.onProductChange(
                    e,
                    mapPropsForProduct(product),
                    reason,
                    details
                  );
                  setLocalError(true);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={styles.editProductOrderOffer}
                    InputProps={{
                      style: {
                        fontWeight: props.isOrderOffer ? "bold" : "normal",
                        ...(props?.applyStyle
                          ? { minWidth: isMobile() ? "100%" : "20vw" }
                          : {}),
                      },
                      ...params.InputProps,
                      rows: 4,
                      multiline: false,
                      inputComponent: "textarea",
                    }}
                    fullWidth={true}
                    name={`vehicles.brand`}
                    error={!localError && !!error}
                    helperText={!localError && error?.message}
                    label={Vocabulary.vehicle}
                    variant={props.applyStyle ? "standard" : "outlined"}
                  />
                )}
              />
            </>
          );
        }}
      />
    </Fragment>
  );
};
